/* eslint-disable react/prop-types */
import React, { useEffect, useState }  from "react";
import { Grid, Box, Typography } from "@material-ui/core";
import {useAppDispatch} from "../../../redux/store";
import {setImage} from "../../../redux/images/images.actions";
import { useLightbox, SRLWrapper } from "simple-react-lightbox";


const MessageItem = ({author, body}) => {
    const dispatch = useAppDispatch();
    const { openLightbox } = useLightbox();
    let image = "";
    if (String(body).startsWith("[img]") && String(body).endsWith("[/img]")) {
        const imageArray = RegExp(/\[img\](.*?)\[\/img\]/g).exec(body);
        image = imageArray && Array.isArray(imageArray) && imageArray[1] || "";
    }
    let hyperlink = "";
    if (String(body).includes('<a href=')) {
        hyperlink = String(body).split('<a href=>').pop().split('</a>')[0];
    }

    const options = {
        settings: {
            autoplaySpeed: 3000,
            boxShadow: "none",
            disableKeyboardControls: false,
            disablePanzoom: false,
            disableWheelControls: false,
            hideControlsAfter: false,
            lightboxTransitionSpeed: 0.3,
            lightboxTransitionTimingFunction: "linear",
            overlayColor: "rgba(30, 30, 30, 0.9)",
            slideAnimationType: "fade",
            slideSpringValues: [300, 50],
            slideTransitionSpeed: 0.6,
            slideTransitionTimingFunction: "linear",
            usingPreact: false
        },
        buttons: {
            showAutoplayButton: false,
            showCloseButton: true,
            showDownloadButton: false,
            showFullscreenButton: true,
            showNextButton: false,
            showPrevButton: false,
            showThumbnailsButton: false,
        },
        caption: {
            showCaption: false
        },
        thumbnails: {
            showThumbnails: false,
        }
    };
    return (
        <Box marginBottom="100px">
            <Grid container alignItems="flex-start" style={{verticalAlign: "center"}}>
                <Typography variant="h4">{author}:&nbsp;</Typography>
                {
                    image
                        ? <SRLWrapper options={options}>
                            <img
                                alt="image sent by user in chat" 
                                src={image}
                                width="60%"
                                style={{objectFit: "contain", cursor: "pointer"}}
                                onClick={() => {
                                    dispatch(setImage(""));
                                    setTimeout(() => {
                                        //openLightbox();
                                    }, 400);
                                }}
                            />
                        </SRLWrapper>
                        : hyperlink ?
                        <Typography variant="body1">
                            <a target="_blank" rel="noreferrer" href={hyperlink}>{hyperlink}</a>
                        </Typography>
                        : <Typography variant="body1" style={{overflow: "normal", wordBreak: "normal"}}>{body}</Typography>
                }
            </Grid>
        </Box>
    );
};

export default MessageItem;
